<template>
    <div
        :tabindex="tabindex"
        class="field-element
            field-element--pseudo-dropdown
            field-element--text
            field-element--totalselector
            field-element--anchor-right
            field-element--search-guests"
        :class="[{
            'field-element--required': required,
            'field-element--error': error,
            'field-element--disabled': disabled,
            'field-element--totalselector--active': active,
        }, styleClasses ]"
        ref="totalSelector"
        @focusin="openTotalSelector"
        @blur="closeTotalSelector"
        @focusout="closeTotalSelector"
    >

        <div class="field-label">
            <label :for="name">{{ label }}</label>
            <span v-if="required" class="field-label__required">required</span>
        </div>

        <div class="field-input pseudo-dropdown__input">
            <input
                :class="[
                    'textbox', 'total-selector__output',
                    value == '' ? 'placeholder' : '',
                ]"
                readonly="1"
                type="text"
                :value="prettyValue()"
                @focus="openTotalSelector"
                @blur="closeTotalSelector"
            >
            <input
                v-for="(quantity, index) in quantities"
                :key="index"
                type="hidden"
                :name="quantity.name"
                :value="value[index]"
            />
            <div
                v-if="active"
                tabindex="0"
                class="field-element--totalselector__dropdown bg-white"
                @click="noop"
            >
                <div class="total-selector__dropdown__fields">

                    <div
                        v-for="(quantity, key) in quantities"
                        :key="key"
                        class="total-selector__dropdown__field"
                    >
                        <div class="total-selector__dropdown__field__labels">
                            <p class="total-selector__dropdown__field__labels__title">
                                {{ quantityTitle(key) }}
                                <span v-if="quantity.helper" class="total-selector__dropdown__field__labels__helper">{{ quantity.helper }}</span>
                            </p>
                        </div>
                        <div class="total-selector__dropdown__field__buttons">

                            <button
                                :class="[
                                    'total-selector__dropdown__field__button',
                                    'total-selector__dropdown__field__button--decrease',
                                    { 'total-selector__dropdown__field__button--min': minReached(key) },
                                ]"
                                type="button"
                                @click="takeOne(key)"
                            >
                                <span class="-vis-hidden">Decrease</span>
                            </button>

                            <input
                                type="text"
                                class="textbox no-spinner total-selector__dropdown__field__total"
                                readonly="1"
                                :value="value[key]"
                                :min="quantity.minimum"
                                :max="quantity.maximum"
                            >

                            <button
                                :class="[
                                    'total-selector__dropdown__field__button',
                                    'total-selector__dropdown__field__button--increase',
                                    { 'total-selector__dropdown__field__button--max': maxReached(key) },
                                ]"
                                type="button"
                                @click="addOne(key)"
                            >
                                <span class="-vis-hidden">Increase</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'FieldTotalSelector',
    props: {
        name: {
            type: String,
        },
        helper: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        label: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        tabindex: {
            type: String,
            default: () => '0',
        },
        styles: {
            type: Array,
            default: () => [],
        },
        quantities: {
            type: Object,
        },
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            active: false,
            error: false,
        };
    },
    computed: {
        styleClasses() {
            return this.styles
                .map(value => 'field-element--' + value)
                .join(' ');
        },
    },
    methods: {
        noop(event) {
            event.stopPropagation();
        },
        openTotalSelector() {
            this.active = true;
        },
        closeTotalSelector() {
            setTimeout(() => {
                if (this.$refs.totalSelector.contains(document.activeElement)) return;
                this.active = false;
            }, 100);
        },
        addOne(key) {
            if (this.value[key] < this.quantities[key].maximum) {
                let value = this.value;
                value[key]++;
                this.$emit('update:value', value);
            }
        },
        takeOne(key) {
            if (this.value[key] > this.quantities[key].minimum) {
                let value = this.value;
                value[key]--;
                this.$emit('update:value', value);
            }
        },
        maxReached(key) {
            if (this.value[key] == this.quantities[key].maximum) {
                return true;
            } else {
                return false;
            }
        },
        minReached(key) {
            if (this.value[key] == this.quantities[key].minimum) {
                return true;
            } else {
                return false;
            }
        },
        quantityTitle(key) {
            if (this.value[key] == 1) {
                return this.quantities[key].title;
            } else {
                return this.quantities[key].title + 's';
            }
        },
        prettyValue() {
            return Object.entries(this.value)
                .map(([key, value]) => value + ' ' + this.quantityTitle(key))
                .join(', ');
        },
    },
};
</script>

<style lang="scss">
@import 'fractal/_patterns/01-components/forms/_form-field-anchors.scss';

.field-element--totalselector {
    position: relative;
}
.field-element--totalselector .field-input .total-selector__output {
    @include form-textbox;
    @include form-textbox-styles;
    background-color: $color-white;
    background-image:
        url(~@/assets/icon-system/icon_form_arrow-down.svg),
        url(~@/assets/icon-system/form_bg-fill.svg);
    background-repeat:
        no-repeat,
        repeat-Y;
    background-position:
        center right 8px,
        center right;
    background-size:
        24px,
        40px;
    padding-right: 52px;
}

.field-element--guests .field-input .total-selector__output {
    background-image:
        url(~@/assets/icon-system/icon_persons.svg),
        url(~@/assets/icon-system/icon_form_arrow-down.svg),
        url(~@/assets/icon-system/form_bg-fill.svg);
    background-repeat:
        no-repeat,
        no-repeat,
        repeat-Y;
    background-position:
        center left 12px,
        center right 8px,
        center right;
    background-size:
        16px,
        24px,
        40px;
    padding-left: 40px;
    padding-right: 40px;
}

.field-element--totalselector__dropdown {
    position: absolute;
    background: $color-white;
    top: 100%;
    left: 0;
    right: 0;
    padding: 20px 24px;
    margin-top: 2px;
    border-radius: 4px;
    z-index: 800;
    border: 1px solid $color-grey-02;
    display: none;
    white-space: nowrap;
    text-transform: none;
}

.field-element--pseudo-dropdown {
    .field-input .total-selector__output {
        background-color: $color-white;
        width: 100%;
        max-width: 100%;
    }
}

.field-element--anchor-right .field-element--totalselector__dropdown {
    left: auto;
    right: 0;
}

.field-element--totalselector.field-element--totalselector--active .field-element--totalselector__dropdown {
    display: block;
}

.field-element--totalselector__dropdown:before {
    @extend %form-field-pseudo-anchor--before-lhs;
}

.field-element--totalselector__dropdown:after {
    @extend %form-field-pseudo-anchor--after-lhs;
}

.field-element--anchor-right .field-element--totalselector__dropdown:before {
    @extend %form-field-pseudo-anchor--before-rhs;
}

.field-element--anchor-right .field-element--totalselector__dropdown:after {
    @extend %form-field-pseudo-anchor--after-rhs;
}

.total-selector__dropdown__field {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 0 0 16px;
}

.total-selector__dropdown__field:last-child {
    margin-bottom: 0;
}

.total-selector__dropdown__field__labels {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

/* BP Extra small */
@media only screen and (min-width: 37.5em) { /* 600px */
    .field-element--totalselector__dropdown {
        right: auto;
        min-width: 320px;
    }
    .total-selector__dropdown__field__labels__helper {
        font-size: 75%;
        line-height: 1;
    }
    .total-selector__dropdown__field {
        margin: 0 0 24px;
    }
}

/* BP Small */
@media only screen and (min-width: 48.063em) { /* 769px */
    /* Don't really need this close button above tablet */
    .total-selector__dropdown__close__button-wrap {
        display: none;
    }
}
</style>
